var styles = {"tabNavigationItem":"TabNavigationItem-module_tabNavigationItem__o-ags","isCurrent":"TabNavigationItem-module_isCurrent__QEa4m","label":"TabNavigationItem-module_label__LsIkC","leadingIcon":"TabNavigationItem-module_leadingIcon__qRr8K","trailing":"TabNavigationItem-module_trailing__0Fpqu"};

export { styles as default };
